import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore, routeParams } from '../../../../../shared/shared.global-service';
import { selectServiceSettings } from '../../../../store/service/service.selectors';
import { isFolderStatusAllowed } from '../../../../../../../../../types/src/services/enum/folder-status.enum';
import { healthcareCalendarSettingsKey } from '../../../../../../utils/healthcare-calendar-settings.utils';

@Injectable()
export class ServiceSettingsSchedulerStore extends ComponentStoreV2Factory {

    public readonly settingsKey = healthcareCalendarSettingsKey();

    public settings = toSignal(globalStore!.select(
        selectServiceSettings(this.settingsKey),
    ));

    public visitsAllowed = computed(() => {
        const expertise = this.globalGlobalStore.organizationStore.getServiceBySignalId(routeParams.serviceId)()?.expertise?.code;
        const { visitsAllowed } = isFolderStatusAllowed(expertise);

        return visitsAllowed;
    });

}
